import {
  Button,
  ButtonGroup,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Autocomplete from "@mui/material/Autocomplete";
import React, { useEffect, useState, useRef } from "react";
import { vantagePath } from "../utils/varialbles";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import toast, { Toaster } from "react-hot-toast";
import handleValidation from "../utils/handleValidations";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "20px",
    marginBottom: 30,
  },
  paper: {
    marginTop: 20,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    minWidth: 300,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  reviewButton: {
    borderRadius: "20px",
    border: "1px solid #2835D5",
    opacity: 1,
    textAlign: "right",
  },
  checked: {},
}));

function EditVantage() {
  let form = {
    Country: "India",
    Investment_Name: "",
    Asset_Class: "",
    Sector: "",
    Industry: "",
    ISINCode: "",
    Microcap: false,
    IPO: false,
    NFO: false,
    ELSS: false,
    Status: "A",
    Rscore: 0,
    Iscore: 0,
    Research_Note: "",
    EFG_min: 0,
    EFG_max: 0,
    type: 2,
    shortname: "",
  };
  const classes = useStyles();
  const history = useHistory();
  const [publishedActive, setPublishedActive] = useState(true);
  const [archivedActive, setArchivedActive] = useState(false);
  const [efgActive, setEfgActive] = useState(false);
  const [formObject, setFromObject] = useState(form);
  const [activeInv, setActiveInv] = useState(true);
  const [watchList, setwatchList] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [asset_Class, setAsset_Class] = useState([]);
  const [sector, setSector] = useState([]);
  const [industry, setIndustry] = useState([]);
  let [lookupFile, setLookupFile] = useState(null);
  const fileInputRef = useRef(null);

  const location = useLocation();
  const myparam = location.state;
  const [fallBack, setFallBack] = useState(false);
  const [q1List, setQ1List] = useState(false);
  const [defaultCompany, setDefaultCompany] = useState("");
  const [efgQue, setEfgQue] = useState(false);
  const [themeCust, setThemeCust] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [otpField, setotpField] = useState("");

  const validations = {
    Investment_Name: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    ISINCode: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    Asset_Class: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    Rscore: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    Iscore: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    // "Research_Note": {
    //     conditions: {
    //         "required": true
    //     }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
    // },
    Sector: {
      conditions: {
        conditionalRequired: true,
        conditionValue: "Stock",
        conditionField: "Asset_Class",
        conditionOperator: "eq",
        conditionFieldValue: null,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    Industry: {
      conditions: {
        conditionalRequired: true,
        conditionValue: "Stock",
        conditionField: "Asset_Class",
        conditionOperator: "eq",
        conditionFieldValue: null,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    shortname: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
  };
  const [validationState, setValidationState] = useState(validations);

  const handleChange = (event, boolean) => {
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    let validation = null;
    if (name && validStateTemp.hasOwnProperty(name)) {
      if (
        validStateTemp[name]["conditions"].hasOwnProperty(
          "conditionalRequired"
        ) &&
        validStateTemp[name]["conditions"].hasOwnProperty("conditionField") &&
        validStateTemp[name]["conditions"].hasOwnProperty(
          "conditionOperator"
        ) &&
        validStateTemp[name]["conditions"].hasOwnProperty("conditionValue") &&
        formObject.hasOwnProperty(
          validStateTemp[name]["conditions"]["conditionField"]
        )
      ) {
        validStateTemp[name]["conditions"]["conditionFieldValue"] =
          formObject[validStateTemp[name]["conditions"]["conditionField"]];
        validation = handleValidation(name, value, validStateTemp);
      } else {
        validation = handleValidation(name, value, validStateTemp);
      }

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value == 0) {
      let finalObjet = { ...formObject };
      finalObjet[name] = value;
      let validStateTemp = { ...validationState };
      let validData = handleSubmitValidation(finalObjet, validStateTemp);
      setValidationState(validData.validStateTemp);
      if (boolean && value === "false") {
        value = false;
      } else if (boolean && value == "true") {
        value = true;
      }
      setFromObject({
        ...formObject,
        [event.target.name]: value,
      });
    }
  };

  useEffect(() => {
    if (myparam && myparam.id) {
      http
        .get("/companylistedit/" + myparam.id)
        .then((resp) => {
          if (resp && resp.data) {
            if (resp.data.Investment_Name) {
              const url = encodeURI(
                "/companynamequery?company_name=" + resp.data.Investment_Name
              );
              const encodedURL = url.replace(/&/g, "%26");
              http
                .get(encodedURL)
                .then((response) => {
                  if (
                    response &&
                    response.data &&
                    response.data.Data &&
                    Array.isArray(response.data.Data) &&
                    response.data.Data.length > 0
                  ) {
                    let data = response.data.Data.map((obj) => {
                      return { label: obj.companyname, id: obj.id };
                    });
                    let currentInvestment = data.filter((obj) => {
                      return obj.companyname === response.data.Investment_Name;
                    });
                    getInitCompanyDetails(
                      null,
                      currentInvestment[0],
                      resp.data
                    );
                    setDefaultCompany(currentInvestment[0]);
                    setCompanyList(data);
                  } else {
                    setCompanyList([]);
                  }
                })
                .catch((error) => {});
            }
          } else {
            // setCompanyList([])
          }
        })
        .catch((error) => {});
    }
  }, []);
  const gotoVantage = (event) => {
    history.push({
      pathname: vantagePath,
      state: { tab: "Lists", subTab: "Watch List" },
    });
  };
  const getInitCompanyDetails = (event, value, data) => {
    if (value && value.id && value.label) {
      setFromObject({
        ...formObject,
        Investment_Name: value.label,
      });
      http
        .get("/vantagelistscreate?id=" + value.id)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.Data &&
            Array.isArray(response.data.Data) &&
            response.data.Data.length > 0
          ) {
            let asset_Class_temp = [];
            let sector_temp = [];
            let industory_temp = [];
            let ac = response.data.Data.map((obj) => {
              if (obj.type === data.Asset_Class) {
                asset_Class_temp.push(obj.type);
              }
              return { label: obj.type, id: obj.id };
            });
            setAsset_Class(ac);
            let se = response.data.Data.map((obj) => {
              if (obj.sector === data.Sector) {
                sector_temp.push(obj.sector);
              }
              return { label: obj.sector, id: obj.id };
            });
            setSector(se);
            let industrys = response.data.Data.map((obj) => {
              if (obj.industry === data.Industry) {
                industory_temp.push(obj.industry);
              }
              return { label: obj.industry, id: obj.id };
            });
            setIndustry(industrys);
            setFromObject({
              Country:
                data.Country && data.Country === "INDIA"
                  ? "India"
                  : data.Country,
              Investment_Name: value.label,
              Asset_Class:
                asset_Class_temp.length > 0 ? asset_Class_temp[0] : "",
              Sector: sector_temp.length > 0 ? sector_temp[0] : "",
              Industry: industory_temp.length > 0 ? industory_temp[0] : "",
              ISINCode: data.ISINCode,
              Microcap: data.Microcap,
              IPO: data.IPO,
              NFO: data.NFO,
              ELSS: data.ELSS,
              Status: data.Status,
              Rscore: data.Rscore,
              Iscore: data.Iscore,
              Research_Note: "",
              EFG_min: data.EFG_min,
              EFG_max: data.EFG_max,
              type: data.type,
              shortname: data.shortname || "",
            });
          } else {
            setAsset_Class([]);
            setSector([]);
            setIndustry([]);
          }
        })
        .catch((error) => {});
    } else {
      setDefaultCompany("");
      setCompanyList([]);
      setAsset_Class([]);
      setSector([]);
      setIndustry([]);
    }
  };

  const handleOTPRequest = () => {
    setDialog(true);
    const actionobj = {
      Action: "Edit Recommendation",
      Stock: defaultCompany.label,
      Section: "WatchList",
    };

    http
      .post("/verification_view", actionobj)
      .then((res) => {
        toast.success("OTP Sent Successfully!");
      })
      .catch((err) => {
        toast.error("OTP Request Failed!");
      });
  };

  const handleOTP = (e) => {
    setotpField(e.target.value);
    // console.log(otpField, "OTP");
  };
  const handleFileChange = (event) => {
    // let validStateTemp = { ...validationState }
    // let validation = handleValidation("Research_Note", event.target.files && event.target.files[0] ? event.target.files[0] : null, validStateTemp);
    // setValidationState(validation.validStateTemp)
    // (event.target.files[0])
    setLookupFile(event.target.files[0]);
  };
  const handleSubmit = (e) => {
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };

    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;
    if (validCount === 0) {
      const formData = new FormData();
      const finalObject = { ...formObject };

      formData.append("Investment_Name", finalObject["Investment_Name"]);
      formData.append("Country", finalObject["Country"]);
      formData.append("Asset_Class", finalObject["Asset_Class"]);
      formData.append("Sector", finalObject["Sector"]);
      formData.append("Industry", finalObject["Industry"]);
      formData.append("ISINCode", finalObject["ISINCode"]);
      formData.append("Microcap", finalObject["Microcap"]);
      formData.append("IPO", finalObject["IPO"]);
      formData.append("NFO", finalObject["NFO"]);
      formData.append("ELSS", finalObject["ELSS"]);

      formData.append("Status", finalObject["Status"]);
      formData.append("Rscore", finalObject["Rscore"]);
      formData.append("Iscore", finalObject["Iscore"]);
      if (lookupFile) {
        formData.append("Research_Note", lookupFile, lookupFile["name"]);
      }
      formData.append("EFG_min", finalObject["EFG_min"]);
      formData.append("EFG_max", finalObject["EFG_max"]);
      formData.append("type", finalObject["type"]);
      formData.append("shortname", formObject["shortname"]);

      http
        .put(
          "/companylistedit/" + myparam.id + "/" + "?otp=" + otpField,
          formData
        )
        .then((res) => {
          if (res && res.data && res.data.id) {
            toast.success("Data Updated Successfully");
            gotoVantage();
          } else {
            toast.error("Data Updation Failed");
          }
        })
        .catch((error) => {
          toast.error("Failed to Update data..!");
        });
    } else {
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };
  const getCompanyList = (event) => {
    let companyName = event.target.value;
    if (companyName && companyName.length > 2) {
      http
        .get("/companynamequery?company_name=" + companyName)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.Data &&
            Array.isArray(response.data.Data) &&
            response.data.Data.length > 0
          ) {
            let data = response.data.Data.map((obj) => {
              return { label: obj.companyname, id: obj.id };
            });

            setCompanyList(data);
          } else {
            setCompanyList([]);
          }
        })
        .catch((error) => {});
    }
  };

  const getCompanyDetails = (event, value) => {
    let valid = true;
    let validStateTemp = { ...validationState };
    if (validStateTemp.hasOwnProperty("Investment_Name")) {
      let validation = handleValidation(
        "Investment_Name",
        value && value.label ? value.label : null,
        validStateTemp
      );

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value == 0) {
      if (value && value.id && value.label) {
        setDefaultCompany(value);
        http
          .get("/vantagelistscreate?id=" + value.id)
          .then((response) => {
            if (
              response &&
              response.data &&
              response.data.Data &&
              Array.isArray(response.data.Data) &&
              response.data.Data.length > 0
            ) {
              let data = { ...formObject };
              setFromObject({
                Country: data.Country,
                Investment_Name: value.label,
                Asset_Class: "",
                Sector: "",
                Industry: "",
                ISINCode: data.ISINCode,
                Microcap: data.Microcap,
                IPO: data.IPO,
                NFO: data.NFO,
                ELSS: data.ELSS,
                Status: data.Status,
                Rscore: data.Rscore,
                Iscore: data.Iscore,
                Research_Note: "",
                EFG_min: data.EFG_min,
                EFG_max: data.EFG_max,
                type: data.type,
              });

              let ac = response.data.Data.map((obj) => {
                if (obj.type) {
                  return { label: obj.type, id: obj.id };
                }
              });
              setAsset_Class(ac);
              let se = response.data.Data.map((obj) => {
                if (obj.sector) {
                  return { label: obj.sector, id: obj.id };
                }
              });
              setSector(se);
              let industrys = response.data.Data.map((obj) => {
                if (obj.industry) {
                  return { label: obj.industry, id: obj.id };
                }
              });
              setIndustry(industrys);
            } else {
              setAsset_Class([]);
              setSector([]);
              setIndustry([]);
            }
          })
          .catch((error) => {});
      } else {
        setDefaultCompany("");
        setCompanyList([]);
        setAsset_Class([]);
        setSector([]);
        setIndustry([]);
      }
    }
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
      >
        <Grid container component="main">
          <Grid item xs={6} sm={6} md={6}>
            <ButtonGroup>
              <Button
                variant={publishedActive ? "contained" : "outlined"}
                color="primary"
                style={{ marginLeft: 10, borderRadius: 60 }}
                name="invOverView"
                onClick={gotoVantage}
              >
                Lists
              </Button>
              {/* <Button variant={efgActive ? "contained" : "outlined"} color="primary" style={{ marginLeft: 10, borderRadius: 60 }} onClick={() => makeActive("/archivedcontentmanagement")} name="archivedPostsButton">EFG Admin</Button> */}
              {/* <Button variant={archivedActive ? "contained" : "outlined"} color="primary" style={{ marginLeft: 10, borderRadius: 60 }} onClick={() => makeActive("/contentmanagement")} name="publishedPostsButton">Stock Closure Upload</Button> */}
            </ButtonGroup>
          </Grid>
        </Grid>
      </AppBar>

      <Grid container component="main" style={{ marginTop: 30 }}>
        <Grid item xs={false} sm={5} md={5}>
          {/* <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack}>Back</Button> */}
        </Grid>
        <Grid item xs={false} sm={5} md={5}>
          <Typography color="textPrimary" variant="h5">
            view/Edit Recommendation
          </Typography>
        </Grid>

        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="Country" className={classes.lableColor}>
              Country{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>
          <Grid item xs={false} sm={1} md={1}>
            <Select
              displayEmpty
              labelId="mobileCodeLable"
              id="select"
              value={formObject.Country}
              variant="outlined"
              className={classes.select}
              onChange={handleChange}
              name="Country"
            >
              <MenuItem value={"India"}>{"India"}</MenuItem>
              <MenuItem value={"USA"}>{"USA"}</MenuItem>
              <MenuItem value={"Canada"}>{"Canada"}</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="firstNameLable" className={classes.lableColor}>
              Investment Name{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={companyList}
              sx={{ width: 300 }}
              onChange={getCompanyDetails}
              value={defaultCompany}
              renderInput={(params) => (
                <TextField
                  {...params}
                  onChange={getCompanyList}
                  name="nameSearch"
                  variant="outlined"
                  style={
                    validationState.hasOwnProperty("Investment_Name") &&
                    validationState["Investment_Name"]["changed"] &&
                    !validationState["Investment_Name"]["valid"]
                      ? { paddingBottom: 20 }
                      : {}
                  }
                  error={
                    validationState.hasOwnProperty("Investment_Name") &&
                    validationState["Investment_Name"]["changed"] &&
                    !validationState["Investment_Name"]["valid"]
                  }
                  helperText={
                    validationState.hasOwnProperty("Investment_Name") &&
                    validationState["Investment_Name"]["changed"] &&
                    !validationState["Investment_Name"]["valid"]
                      ? validationState["Investment_Name"]["message"]
                      : ""
                  }
                />
              )}
            />
          </Grid>
        </Grid>
        {asset_Class && asset_Class.length > 0 ? (
          <Grid container className={classes.paper}>
            <Grid item xs={false} sm={5} md={5}>
              <InputLabel id="Asset_Class" className={classes.lableColor}>
                Asset Class{" "}
                <span
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "0.2rem",
                  }}
                >
                  *
                </span>
              </InputLabel>
            </Grid>
            <Grid item xs={false} sm={5} md={5}>
              <>
                <Select
                  displayEmpty
                  labelId="assetLable"
                  id="Asset_Class"
                  variant="outlined"
                  className={classes.select}
                  onChange={handleChange}
                  value={formObject.Asset_Class ? formObject.Asset_Class : ""}
                  name="Asset_Class"
                >
                  <MenuItem value="">Select</MenuItem>
                  {asset_Class.map((option) => {
                    return (
                      <MenuItem
                        value={option.label}
                        key={option.label && option.label.trim()}
                      >
                        {option.label}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
                {validationState.hasOwnProperty("Asset_Class") &&
                validationState["Asset_Class"]["changed"] &&
                !validationState["Asset_Class"]["valid"] ? (
                  <div
                    style={{
                      color: "#f44336",
                      fontSize: "0.75rem",
                      margin: "3px 14px",
                    }}
                  >
                    {validationState["Asset_Class"]["message"]}
                  </div>
                ) : null}
              </>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        {sector && sector.length > 0 ? (
          <Grid container className={classes.paper}>
            <Grid item xs={false} sm={5} md={5}>
              <InputLabel id="Sector" className={classes.lableColor}>
                Sector{" "}
                <span
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "0.2rem",
                  }}
                >
                  *
                </span>
              </InputLabel>
            </Grid>
            <Grid item xs={false} sm={5} md={5}>
              <>
                <Select
                  displayEmpty
                  labelId="Sector"
                  id="SectorSelect"
                  variant="outlined"
                  className={classes.select}
                  onChange={handleChange}
                  value={formObject.Sector ? formObject.Sector : ""}
                  name="Sector"
                >
                  <MenuItem value="">Select</MenuItem>
                  {sector.map((option) => {
                    return (
                      <MenuItem
                        value={option.label}
                        key={option.label && option.label.trim()}
                      >
                        {option.label}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
                {validationState.hasOwnProperty("Sector") &&
                validationState["Sector"]["changed"] &&
                !validationState["Sector"]["valid"] ? (
                  <div
                    style={{
                      color: "#f44336",
                      fontSize: "0.75rem",
                      margin: "3px 14px",
                    }}
                  >
                    {validationState["Sector"]["message"]}
                  </div>
                ) : null}
              </>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        {industry && industry.length > 0 ? (
          <Grid container className={classes.paper}>
            <Grid item xs={false} sm={5} md={5}>
              <InputLabel id="Industry" className={classes.lableColor}>
                Industry{" "}
                <span
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "0.2rem",
                  }}
                >
                  *
                </span>
              </InputLabel>
            </Grid>
            <Grid item xs={false} sm={5} md={5}>
              <>
                {" "}
                <Select
                  displayEmpty
                  labelId="Industry"
                  id="IndustrySelect"
                  variant="outlined"
                  className={classes.select}
                  onChange={handleChange}
                  value={formObject.Industry ? formObject.Industry : ""}
                  name="Industry"
                >
                  <MenuItem value="">Select</MenuItem>
                  {industry.map((option) => {
                    return (
                      <MenuItem
                        value={option.label}
                        key={option.label && option.label.trim()}
                      >
                        {option.label}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
                {validationState.hasOwnProperty("Industry") &&
                validationState["Industry"]["changed"] &&
                !validationState["Industry"]["valid"] ? (
                  <div
                    style={{
                      color: "#f44336",
                      fontSize: "0.75rem",
                      margin: "3px 14px",
                    }}
                  >
                    {validationState["Industry"]["message"]}
                  </div>
                ) : null}
              </>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="ISINcodeLable" className={classes.lableColor}>
              ISIN code{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <TextField
              id="ISINcodeField"
              label="Enter"
              variant="outlined"
              className={classes.select}
              name="ISINCode"
              value={formObject.ISINCode}
              onChange={handleChange}
              style={
                validationState.hasOwnProperty("ISINCode") &&
                validationState["ISINCode"]["changed"] &&
                !validationState["ISINCode"]["valid"]
                  ? { paddingBottom: 20 }
                  : {}
              }
              error={
                validationState.hasOwnProperty("ISINCode") &&
                validationState["ISINCode"]["changed"] &&
                !validationState["ISINCode"]["valid"]
              }
              helperText={
                validationState.hasOwnProperty("ISINCode") &&
                validationState["ISINCode"]["changed"] &&
                !validationState["ISINCode"]["valid"]
                  ? validationState["ISINCode"]["message"]
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel
              id="MicroCapInvestmentsLabel"
              className={classes.lableColor}
            >
              Micro-Cap Investments{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="position"
                name="Microcap"
                defaultValue={false}
                value={formObject.Microcap ? formObject.Microcap : false}
                onChange={(e) => handleChange(e, true)}
              >
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={true}
                    />
                  }
                  label="Yes"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={false}
                    />
                  }
                  label="No"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="IPOInvestmentsLabel" className={classes.lableColor}>
              IPO Investments{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="position"
                name="IPO"
                defaultValue={false}
                value={formObject.IPO ? formObject.IPO : false}
                onChange={(e) => handleChange(e, true)}
              >
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={true}
                    />
                  }
                  label="Yes"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={false}
                    />
                  }
                  label="No"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="NFOInvestmentsLabel" className={classes.lableColor}>
              NFO Investments{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="position"
                name="NFO"
                defaultValue={false}
                value={formObject.NFO ? formObject.NFO : false}
                onChange={(e) => handleChange(e, true)}
              >
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={true}
                    />
                  }
                  label="Yes"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={false}
                    />
                  }
                  label="No"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="ELSSCategoryLabel" className={classes.lableColor}>
              ELSS Category{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="position"
                name="ELSS"
                defaultValue={false}
                value={formObject.ELSS ? formObject.ELSS : false}
                onChange={(e) => handleChange(e, true)}
              >
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={true}
                    />
                  }
                  label="Yes"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={false}
                    />
                  }
                  label="No"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel
              id="RecommendationstatusLable"
              className={classes.lableColor}
            >
              Recommendation status{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="position"
                name="Status"
                defaultValue={"B"}
                value={formObject.Status ? formObject.Status : "B"}
                onChange={handleChange}
              >
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={"B"}
                    />
                  }
                  label="Buy"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={"H"}
                    />
                  }
                  label="Hold"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={
                    <Radio
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      value={"S"}
                    />
                  }
                  label="Sell"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="RScoreLable" className={classes.lableColor}>
              R Score{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <TextField
              id="RScoreField"
              label="Enter"
              variant="outlined"
              className={classes.select}
              name="Rscore"
              value={formObject.Rscore}
              onChange={handleChange}
              type="number"
              style={
                validationState.hasOwnProperty("Rscore") &&
                validationState["Rscore"]["changed"] &&
                !validationState["Rscore"]["valid"]
                  ? { paddingBottom: 20 }
                  : {}
              }
              error={
                validationState.hasOwnProperty("Rscore") &&
                validationState["Rscore"]["changed"] &&
                !validationState["Rscore"]["valid"]
              }
              helperText={
                validationState.hasOwnProperty("Rscore") &&
                validationState["Rscore"]["changed"] &&
                !validationState["Rscore"]["valid"]
                  ? validationState["Rscore"]["message"]
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={false} sm={5} md={5}>
            <InputLabel id="IScoreLable" className={classes.lableColor}>
              I Score{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={false} sm={5} md={5}>
            <TextField
              id="IScoreField"
              label="Enter"
              variant="outlined"
              className={classes.select}
              name="Iscore"
              value={formObject.Iscore}
              onChange={handleChange}
              type="number"
              style={
                validationState.hasOwnProperty("Iscore") &&
                validationState["Iscore"]["changed"] &&
                !validationState["Iscore"]["valid"]
                  ? { paddingBottom: 20 }
                  : {}
              }
              error={
                validationState.hasOwnProperty("Iscore") &&
                validationState["Iscore"]["changed"] &&
                !validationState["Iscore"]["valid"]
              }
              helperText={
                validationState.hasOwnProperty("Iscore") &&
                validationState["Iscore"]["changed"] &&
                !validationState["Iscore"]["valid"]
                  ? validationState["Iscore"]["message"]
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={12} sm={5} md={5}>
            <InputLabel id="IScoreLable" className={classes.lableColor}>
              Research Note{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={12} sm={5} md={5}>
            <>
              <input
                ref={fileInputRef}
                onChange={handleFileChange}
                type="file"
                style={{ display: "none" }}
                multiple={false}
                accept=".pdf,.PDF"
              />
              <Button
                startIcon={<AddCircleOutlineIcon />}
                variant="outlined"
                className={classes.reviewButton}
                color="primary"
                onClick={() => fileInputRef.current.click()}
              >
                Choose File
              </Button>
              <span style={{ marginLeft: 10 }}>
                {lookupFile && lookupFile.name
                  ? lookupFile.name
                  : "No file chosen"}
              </span>
              {validationState.hasOwnProperty("Research_Note") &&
              validationState["Research_Note"]["changed"] &&
              !validationState["Research_Note"]["valid"] ? (
                <div
                  style={{
                    color: "#f44336",
                    fontSize: "0.75rem",
                    margin: "3px 14px",
                  }}
                >
                  {validationState["Research_Note"]["message"]}
                </div>
              ) : null}
            </>
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item sm={5} md={5}>
            <InputLabel className={classes.lableColor} id="minscore">
              EFG investment score correspondence range{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={7} md={7}>
            <Grid container>
              <Grid item xs={12} sm={5} md={5} lg={4}>
                <span style={{ marginRight: 5 }}>Min</span>
                <Select
                  displayEmpty
                  value={formObject.EFG_min ? formObject.EFG_min : 0}
                  variant="outlined"
                  name="EFG_min"
                  onChange={handleChange}
                  style={{ minWidth: 150 }}
                >
                  {Array.from(Array(101).keys()).map((value) => {
                    return (
                      <MenuItem key={"h" + value} value={value}>
                        {value}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
              <Grid item xs={12} sm={5} md={5} lg={4}>
                <span tyle={{ marginRight: 5 }}>Max </span>
                <Select
                  displayEmpty
                  value={formObject.EFG_max ? formObject.EFG_max : 0}
                  variant="outlined"
                  name="EFG_max"
                  onChange={handleChange}
                  style={{ minWidth: 150 }}
                >
                  {Array.from(Array(101).keys()).map((value) => {
                    return (
                      <MenuItem key={"m" + value} value={value}>
                        {value}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className={classes.paper}>
          <Grid item xs={12} sm={5} md={5}>
            <InputLabel id="ShortNameLable" className={classes.lableColor}>
              Short Name{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "1.2rem",
                  marginLeft: "0.2rem",
                }}
              >
                *
              </span>
            </InputLabel>
          </Grid>

          <Grid item xs={12} sm={5} md={5}>
            <TextField
              id="shortnameFeild"
              label="Enter"
              variant="outlined"
              className={classes.select}
              name="shortname"
              value={formObject.shortname}
              onChange={handleChange}
              style={
                validationState.hasOwnProperty("shortname") &&
                validationState["shortname"]["changed"] &&
                !validationState["shortname"]["valid"]
                  ? { paddingBottom: 20 }
                  : {}
              }
              error={
                validationState.hasOwnProperty("shortname") &&
                validationState["shortname"]["changed"] &&
                !validationState["shortname"]["valid"]
              }
              helperText={
                validationState.hasOwnProperty("shortname") &&
                validationState["shortname"]["changed"] &&
                !validationState["shortname"]["valid"]
                  ? validationState["shortname"]["message"]
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Grid container className={classes.submitButton}>
          <Grid item xs={false} sm={5} md={5}></Grid>

          <Grid item xs={3} sm={2} md={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOTPRequest}
            >
              Update Investment
            </Button>
          </Grid>
        </Grid>
        <Dialog
          open={dialog}
          onClose={(e) => setDialog(false)}
          aria-labelledby="draggable-dialog-delete"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-delete">
            Add New Recommendation
          </DialogTitle>
          <DialogContent>
            <span>Are you sure you want to update this Recommendation?</span>
            <p>Enter OTP</p>

            <input placeholder="OTP" onChange={handleOTP}></input>
          </DialogContent>
          <DialogActions>
            <Button onClick={(e) => setDialog(false)} variant="outlined">
              No
            </Button>
            <Button
              autoFocus
              onClick={handleSubmit}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </div>
  );
}

export default EditVantage;
